import { render, staticRenderFns } from "./InterstitialTargeting.vue?vue&type=template&id=4afda676&"
import script from "./InterstitialTargeting.vue?vue&type=script&lang=js&"
export * from "./InterstitialTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports